import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaCoins, FaPlus, FaMinus, FaHistory, FaChevronLeft } from "react-icons/fa";
import "./CoinBalance.css";

const CoinBalance = () => {
  const [coins, setCoins] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("user_id");

  const fetchBalance = useCallback(async () => {
    if (!userId || !token) {
      setLoading(false);
      navigate("/login");
      return;
    }
    try {
      const response = await axios.get(`https://backend.aubattle.com/api/coins/balance/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCoins(response.data.coins);
    } catch (err) {
      setError("Failed to fetch balance. Please try again later.");
      console.error("Balance fetch error:", err);
    } finally {
      setLoading(false);
    }
  }, [userId, token, navigate]);

  useEffect(() => {
    fetchBalance();
  }, [fetchBalance]);

  const formatCoins = (amount) => {
    return new Intl.NumberFormat().format(amount);
  };

  return (
    <div className="gb-wallet-container">
      <div className="gb-wallet-header">
        <button className="gb-back-button" onClick={() => navigate(-1)}>
          <FaChevronLeft className="icon" /> BACK
        </button>
        <h1 className="gb-wallet-title">COIN WALLET</h1>
      </div>

      {loading ? (
        <div className="gb-loading-state">
          <div className="gb-spinner"></div>
          <p>Loading your balance...</p>
        </div>
      ) : error ? (
        <div className="gb-error-state">
          <p>{error}</p>
          <button onClick={fetchBalance} className="gb-retry-button">
            RETRY
          </button>
        </div>
      ) : (
        <>
          <div className="gb-balance-card">
            <div className="gb-balance-header">
              <FaCoins className="gb-coin-main-icon" />
              <span>CURRENT BALANCE</span>
            </div>
            <div className="gb-balance-amount">
              {formatCoins(coins)} <span className="gb-coin-unit">COINS</span>
            </div>
            <div className="gb-balance-subtext">
              ≈ ${(coins * 0.1).toFixed(2)} USD {/* Example conversion */}
            </div>
          </div>

          <div className="gb-actions-grid">
            <div className="gb-action-card" onClick={() => navigate("/add-coins")}>
              <div className="gb-action-icon add">
                <FaPlus />
              </div>
              <h3>ADD COINS</h3>
              <p>Deposit funds to your wallet</p>
            </div>

            <div className="gb-action-card" onClick={() => navigate("/withdraw")}>
              <div className="gb-action-icon withdraw">
                <FaMinus />
              </div>
              <h3>WITHDRAW</h3>
              <p>Transfer coins to your account</p>
            </div>

            <div className="gb-action-card" onClick={() => navigate("/transaction")}>
              <div className="gb-action-icon history">
                <FaHistory />
              </div>
              <h3>TRANSACTIONS</h3>
              <p>View your payment history</p>
            </div>
          </div>

          <div className="gb-wallet-info">
            <h3>YOUR GAMING WALLET</h3>
            <p>
              Your journey to rewards begins here! Track your coins, manage transactions, 
              and control your balance. Earn more, withdraw when needed, and dominate the game.
            </p>
            <div className="gb-security-badge">
              <span>🔒 SECURE WALLET</span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CoinBalance;